import React from "react";
import "./Footer.css";
import logoGovBRCor from "../../../../assets/logo/logo-footer-hubrasil.svg";
// import logoHubBrasil from '../../../../assets/logo/logo-hubrasil.svg';

export function Footer() {
  return (
    <div className="footerContent">
      <img className="logoFooterGovbr" alt="logo govbr" src={logoGovBRCor} />
      {/* <img className="ebserhFooterLogo" alt="logo hub brasil" src={logoHubBrasil} /> */}
    </div>
  );
}
